import { LineChartComponent } from '../charts/line-chart-component'

export class AFLatestActivityBySource extends LineChartComponent {
 static config = {
  selector: 'afLatestActivityBySource',
  controller: AFLatestActivityBySource,
  bindings: LineChartComponent.config.bindings,
  template: LineChartComponent.config.template,
 }

 setProperties() {
    this.seriesColors = this.colorUtils.setSourceColorPalette(this.vizData.data)
 }

 onPointClick = obj => {
  let seriesName = obj.seriesName.split(' <br />')[0]
  let payload = seriesName !== 'All' ? this.sourceTypeFilter(obj) : []
  payload.push(this.updatePayloadDate(obj.key, obj.key))
  this.triggerUpdate(payload)
 }
}
